angular.module('bmsApp.settings').controller('UserProfileSaveCtrl',
	function ($scope, $log, AppSettingsSvc, notify, AuthService, UserManagementSvc, $timeout) {

		$scope.processing = false;

		$scope.formValidator = {};

		UserManagementSvc.read(AuthService.getUserObject().id)
			.then(function (response) {
				$scope.user = response.data.user;
			});


		$scope.submit = function (user) {
			$scope.processing = true;

			if ($scope.formValidator.valid()) {
				$scope.processing = true;

				if (!$scope.user.passwordUpdate) {
					delete user.password;
				}

				UserManagementSvc.update(user)
					.then(function (response) {
						notify({
							message: 'Successfully updated'
						});
						processing = false;

					}, function (error) {
						processing = false;
						$scope.errors = error;
					})
					.finally(function () {
						$scope.processing = false;
					});
			}
		};

	});
